import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import { CashmereModule } from './cashmere.module';
import { ApiComponent } from './api/api.component';
import { CatalogComponent } from './catalog/catalog.component';
import { DownloadsComponent } from './downloads/downloads.component';
import { ViewerComponent } from './viewer/viewer.component';
import { AdminModule } from './admin/admin.module';
import { HttpClientModule } from '@angular/common/http';
import { OktaAuthModule } from '@okta/okta-angular';
import { OktaAuth } from '@okta/okta-auth-js';
import { PdfJsViewerModule } from 'ng2-pdfjs-viewer';
import { environment } from '../environments/environment';
import { QuillModule } from 'ngx-quill';
import { SharedModule } from './shared/shared.module';
import { DefinitionsComponent } from './definitions/definitions.component';
import { TechLibraryComponent } from './tech-library/tech-library.component';
import { ChangesComponent } from './changes/changes.component';
import { DownloadsDetailComponent } from './downloads-detail/downloads-detail.component';
import { SourcesComponent } from './sources/sources.component';
import { ReloadComponent } from './reload/reload.component';
import { TechLibraryViewerComponent } from './tech-library-viewer/tech-library-viewer.component';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';

const oktaAuth = new OktaAuth({
    issuer: environment.okta.issuer,
    clientId: environment.okta.clientid,
    redirectUri: window.location.origin + '/login/callback',
    logoutUrl: 'https://healthcatalyst.com'
});
  
@NgModule({
    declarations: [
        AppComponent,
        ApiComponent,
        CatalogComponent,
        DefinitionsComponent,
        DownloadsComponent,
        ViewerComponent,
        TechLibraryComponent,
        ChangesComponent,
        DownloadsDetailComponent,
        SourcesComponent,
        ReloadComponent,
        TechLibraryViewerComponent
    ],
    imports: [
        BrowserModule,
        AppRoutingModule,
        HttpClientModule,
        CashmereModule,
        SharedModule,
        BrowserAnimationsModule,
        AdminModule,
        PdfJsViewerModule,
        OktaAuthModule.forRoot({ oktaAuth }),
        QuillModule.forRoot(),
        FormsModule, 
        ReactiveFormsModule
    ],
    providers: [],
    bootstrap: [AppComponent]
})
export class AppModule {}
